export default __webpack_public_path__ + "static/media/marker-blue-sky-yellow.4b349b30.png";